import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './header.less'

import PayPalLogo from 'components/paypal_logo'
import LoginButton from 'components/login_button'

class TopBar extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['dark', 'light', 'transparent']),
    inGrid: PropTypes.bool,
  }

  static defaultProps = {
    type: 'dark',
  }

  getLogoType = () => {
    switch (this.props.type) {
      case 'transparent':
      case 'dark':
        return 'mono'
      case 'light':
        return 'color'
      default:
        return ''
    }
  }

  render() {
    const dark = this.props.type === 'dark' ? 'dark-' : ''

    return (
      <header styleName={`${dark}top-bar`}>
        <div styleName={this.props.inGrid ? 'container' : 'container-grid'}>
          <div styleName="left-part">
            <PayPalLogo type={this.getLogoType()} />
          </div>
          <div styleName="right-part">
            <LoginButton type={this.props.type} stayOnPageOnLogout={true} />
          </div>
        </div>
      </header>
    )
  }
}

export default cssModules(TopBar, styles)
